import React, { useState, useEffect } from 'react';
import EstateLoading from "../estateOriginality/EstateLoading";
import CarLoading from "../carOriginality/CarLoading"
import NIDCardReaderLoading from "../authentication/loading/NIDCardReaderLoading";
import FaceScanLoading from "../authentication/loading/FaceScanLoading";
import Spinner from "../Spinner";
import OriginalityDeviceLoading from "../originalityDevice/loading/OriginalityDeviceLoading";
function ProgressBar({ duration=30,theme="green",showSpinner,type,text,showProgress=true}) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
            if(showProgress){
                const totalTicks = duration;
                let tick = 0;

                const intervalId = setInterval(() => {

                    tick++;
                    setProgress((tick / totalTicks) * 100);

                    if (tick >= totalTicks) {
                        clearInterval(intervalId);
                    }
                }, 1000); // Update every second

                return () => {
                    clearInterval(intervalId);
                };
            }
    }, [duration]);

    return (
        <div className="flex flex-col justify-center h-screen  items-center">
            {showSpinner && <Spinner className="text-3xl text-green-500 mb-2 "/>}
            {type==="CService" && <CarLoading progress={progress} />}
            {type==="Estate" && <EstateLoading progress={progress} />}
            {(type==="NIDCardReader" ||type==="BusinessLicenseInquiry" || type==="ExpertInquiry" ||type==="LawyerInquiry")  && <NIDCardReaderLoading progress={progress} />}
            {type==="CompareFaces" && <FaceScanLoading progress={progress} />}
            {type==="VideoValidation" && <FaceScanLoading progress={progress} />}
            {type==="HamtaInquiry" && <OriginalityDeviceLoading progress={progress} /> }
            {showProgress &&        <div className="progress-bar h-2 bg-gray-100 relative rounded-xl ">
                <div className="w-full h-2 bg-white border border-gray-100 rounded-xl"></div>
                <div className={`progress text-xs text-white h-2 top-0 absolute ${theme ? `bg-${theme}-500` :'bg-blue-600'} rounded-xl`} style={{ width: `${progress}%` }}/>

            </div>}
            <div className="w-full flex justify-center">
                <span className="w-full text-center mt-3  text-sm">{text ? text:'لطفا منتظر بمانید'}</span>
            </div>
        </div>
    );
}

export default ProgressBar;